import { ArgsInitSliceMeta, ReferenceOfMeta } from '@vs/rtk/utils';

export const referenceOfMeta: ReferenceOfMeta = {
  _envConfig: undefined,
  _deployEnv: undefined,
  _baseUrl: undefined,
  _getTokenFunc: undefined,
  _getUserIdFunc: undefined,
};

export function initSliceMeta({
  deployEnv,
  baseUrl,
  env,
  getTokenFunc,
  getUserIdFunc,
}: ArgsInitSliceMeta) {
  referenceOfMeta._deployEnv = deployEnv;
  referenceOfMeta._envConfig = env;
  referenceOfMeta._baseUrl = baseUrl;
  referenceOfMeta._getTokenFunc = getTokenFunc as () => Promise<string | null>;
  referenceOfMeta._getUserIdFunc = getUserIdFunc;
}
